/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoState
 */
export interface HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoState {
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoState
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoState
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoState
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoState
     */
    country_id?: string;
}

/**
 * Check if a given object implements the HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoState interface.
 */
export function instanceOfHchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoState(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoStateFromJSON(json: any): HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoState {
    return HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoStateFromJSONTyped(json, false);
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'country_id': !exists(json, 'country_id') ? undefined : json['country_id'],
    };
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoStateToJSON(value?: HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'code': value.code,
        'country_id': value.country_id,
    };
}

